module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_7016.f54cdb06.png";